import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useEmployeeProfile } from '~/data/employeeProfile';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';
import { EmployeeRolesSelector } from '~/scenes/PeopleModule/components/EmployeeActions/ChangeRole/EmployeeRolesSelector';

import { useChangeRole } from './useChangeRole';

type Props = AccountManagementMenu_OnUpdateLegacy & {
  open: boolean;
  onClose: () => void;
};

export const ChangeRole = ({ open, onClose, onUpdateLegacy }: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { profile } = useEmployeeProfile();
  const getTitleWithEmployeeName = useCallback(
    (title) =>
      !!profile ? `${title} - ${profile.firstName} ${profile.lastName}` : title,
    [profile],
  );

  const onSubmitSuccess = useCallback(() => {
    if (!!onUpdateLegacy) {
      onUpdateLegacy(['changeRole']);
    }
    onClose();
  }, [onUpdateLegacy, onClose]);

  const { handleRolesChange, onSubmit, employeeRoles } = useChangeRole({
    onSubmitSuccess,
  });
  const handleFormSubmit = () => {
    if (employeeRoles.length === 0) {
      enqueueSnackbar(t('laFillManFields'), {
        variant: 'error',
      });
    } else {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <SolaForceDialogTitle onClose={onClose}>
        {getTitleWithEmployeeName(t('laChangeRole'))}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <EmployeeRolesSelector
          name={'fUserRoles'}
          value={employeeRoles}
          onChange={handleRolesChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={'secondary'}>
          {t('cancel')}
        </Button>
        <Button onClick={handleFormSubmit}>{t('save')}</Button>
      </DialogActions>
    </Dialog>
  );
};
